import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "@phosphor-icons/react";

export default function LockedFeature({ addonKey, name, description }) {
  return (
    <div className="max-w-2xl">
      <div className="overline">Add-on required</div>
      <h1 className="text-3xl mb-6">{name}</h1>
      <div className="paper-card p-10 text-center relative overflow-hidden">
        <div className="w-14 h-14 rounded-full bg-[#E6E2D6] mx-auto flex items-center justify-center mb-4">
          <Lock size={22} color="#1E3A2F" />
        </div>
        <h2 className="text-2xl mb-2">Turn on {name} to unlock this page</h2>
        <p className="text-[#5C6B61] max-w-md mx-auto mb-6">{description}</p>
        <Link to="/pricing" className="btn-primary inline-flex" data-testid={`upgrade-${addonKey}`}>
          Choose your add-ons <ArrowRight size={16} color="#fff" />
        </Link>
        <p className="text-xs text-[#5C6B61] mt-4">No commitment · No contract · Cancel anytime</p>
      </div>
    </div>
  );
}
